import type { ReactNode } from 'react';
import { RowWrapper } from '../../RowWrapper';

export const BreakdownRowWrapper = ({ children }: { children: ReactNode }) => (
  <RowWrapper
    size="md"
    separator
  >
    {children}
  </RowWrapper>
);
